<script lang="ts" setup>
import userStore from '@/store/UserStore.ts'
import { MountingMaterial } from '@/models/MountingMaterial.ts'

defineProps<{
  mountingMaterial: MountingMaterial
}>()

</script>

<template>
  <svg
    :class="{
      'brand-va': userStore.brand === 'VAILLANT',
      'brand-sd': userStore.brand === 'SDBG'
    }"
    fill="none"
    viewBox="0 0 100 89"
    xmlns="http://www.w3.org/2000/svg">

    <g v-if="mountingMaterial === MountingMaterial.STANDARD_FEET">
      <path
        d="M50.0001 47.4848V1.11133L10.7844 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        d="M50 47.4848V1.11133L89.2157 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        clip-rule="evenodd" d="M49.8501 87.7128L0.980469 67.6262L49.8501 47.5415L98.7187 67.6262L49.8501 87.7128Z" fill-rule="evenodd"
        stroke="#CCCCCC"
        stroke-dasharray="3 3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M40.3132 59.1957H43.2544V61.6413C43.2544 62.4517 42.596 63.1087 41.7838 63.1087C40.9716 63.1087 40.3132 62.4517 40.3132 61.6413V59.1957Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored"
        d="M60.9412 66H58V68.4457C58 69.2561 58.6584 69.913 59.4706 69.913C60.2828 69.913 60.9412 69.2561 60.9412 68.4457V66Z" />
      <path
        class="brand-colored"
        d="M68.9412 63H66V65.4457C66 66.2561 66.6584 66.913 67.4706 66.913C68.2828 66.913 68.9412 66.2561 68.9412 65.4457V63Z" />
      <path
        clip-rule="evenodd"
        d="M68.8098 43.0836L49.7804 35.2174L40.2176 39.1471L40.2294 39.1529L40.196 39.1471V58.1654L40.2176 58.2329L59.4568 66.1402L68.9647 62.2331L69.0206 62.1978V43.1129L68.8098 43.0836Z"
        fill="white"
        fill-rule="evenodd" />
      <path
        clip-rule="evenodd" d="M68.5 43L59.4572 47.0553L40.219 39.1481L49.7798 35.2174L68.5 43Z" fill-rule="evenodd" stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
      <path
        d="M40.196 39.1481V58.1655L40.2176 58.232L59.4568 66.1403L68.6274 62.2321" stroke="#333333" stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M43 59L43.1372 40.7347" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M46.0784 60.4125L46 42" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M49.001 61L49.0195 42.9818" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M51.9607 63.1066V44.0217" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M59.804 66.0953V47.0114" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        clip-rule="evenodd"
        d="M68.6274 43.0836L49.7804 35.2174L40.2176 39.1471L40.2294 39.1529L40.196 39.1471V58.1654L40.2176 58.2329L59.4568 66.1402L68.6274 62.2331V43.0836Z"
        fill-rule="evenodd"
        stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    </g>

    <g v-if="mountingMaterial === MountingMaterial.ANTI_VIBRATION_FEET">
      <path
        d="M50.0001 47.4848V1.11133L10.7844 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        d="M50 47.4848V1.11133L89.2157 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        clip-rule="evenodd" d="M49.8501 87.7128L0.980469 67.6262L49.8501 47.5415L98.7187 67.6262L49.8501 87.7128Z" fill-rule="evenodd"
        stroke="#CCCCCC"
        stroke-dasharray="3 3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M58.3891 62.6651L59.8597 65.2122L52.7417 68.435C52.0399 68.8402 51.1417 68.5985 50.7356 67.8952C50.3295 67.1918 50.5693 66.2931 51.2711 65.8879L58.3891 62.6651Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M64.4708 63.1686L63.0002 60.6214L70.1182 57.3986C70.82 56.9934 71.7182 57.2351 72.1243 57.9385C72.5304 58.6418 72.2906 59.5405 71.5888 59.9457L64.4708 63.1686Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M46.3891 57.6651L47.8597 60.2122L40.7417 63.435C40.0399 63.8402 39.1417 63.5985 38.7356 62.8952C38.3295 62.1918 38.5693 61.2931 39.2711 60.8879L46.3891 57.6651Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M49.4705 58.1687L47.9999 55.6215L55.1179 52.3987C55.8198 51.9935 56.7179 52.2352 57.124 52.9386C57.5301 53.642 57.2904 54.5406 56.5885 54.9459L49.4705 58.1687Z"
        fill-rule="evenodd" />
      <path
        clip-rule="evenodd"
        d="M68.8098 43.0836L49.7804 35.2174L40.2176 39.1471L40.2294 39.1529L40.196 39.1471V58.1654L40.2176 58.2329L59.4568 66.1402L68.9647 62.2331L69.0206 62.1978V43.1129L68.8098 43.0836Z"
        fill="white"
        fill-rule="evenodd" />
      <path
        clip-rule="evenodd" d="M68.5002 43L59.4575 47.0553L40.2192 39.1481L49.78 35.2174L68.5002 43Z" fill-rule="evenodd" stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
      <path
        d="M40.196 39.1481V58.1655L40.2176 58.232L59.4568 66.1403L68.6274 62.2321" stroke="#333333" stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M43 59L43.1372 40.7347" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M46.0784 60.4125L46 42" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M49.001 61L49.0195 42.9818" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M51.9609 63.1066V44.0217" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M59.804 66.0953V47.0114" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        clip-rule="evenodd"
        d="M68.6274 43.0836L49.7804 35.2174L40.2176 39.1471L40.2294 39.1529L40.196 39.1471V58.1654L40.2176 58.2329L59.4568 66.1402L68.6274 62.2331V43.0836Z"
        fill-rule="evenodd"
        stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    </g>
    <g v-if="mountingMaterial === MountingMaterial.WALL_MOUNT">
      <path
        d="M50.0001 47.4848V1.11133L10.7844 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        d="M50 47.4848V1.11133L89.2157 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        clip-rule="evenodd" d="M49.8501 87.7128L0.980469 67.6262L49.8501 47.5415L98.7187 67.6262L49.8501 87.7128Z" fill-rule="evenodd"
        stroke="#CCCCCC"
        stroke-dasharray="3 3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M74.3891 45.4478L75.8597 47.9949L68.7417 51.2177C68.0399 51.6229 67.1417 51.3812 66.7356 50.6779C66.3295 49.9745 66.5693 49.0758 67.2711 48.6706L74.3891 45.4478Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M73.1688 48.8691L73.8164 46.0001L81.2323 48.4612C82.0228 48.6397 82.5187 49.4266 82.3399 50.2188C82.1611 51.0111 81.3752 51.5087 80.5847 51.3302L73.1688 48.8691Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M61.3891 40.4477L62.8597 42.9948L55.7417 46.2176C55.0399 46.6228 54.1417 46.3811 53.7356 45.6777C53.3295 44.9744 53.5693 44.0757 54.2711 43.6705L61.3891 40.4477Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M63.4703 40.9513L61.9997 38.4041L69.1177 35.1813C69.8195 34.7761 70.7177 35.0178 71.1238 35.7212C71.5299 36.4246 71.2901 37.3232 70.5883 37.7284L63.4703 40.9513Z"
        fill-rule="evenodd" />
      <path
        clip-rule="evenodd"
        d="M82.8095 25.8662L63.7801 18L54.2174 21.9297L54.2291 21.9355L54.1958 21.9297V40.948L54.2174 41.0155L73.4566 48.9228L82.9644 45.0156L83.0203 44.9804V25.8955L82.8095 25.8662Z"
        fill="white"
        fill-rule="evenodd" />
      <path
        clip-rule="evenodd" d="M82.4998 25.7826L73.457 29.8379L54.2188 21.9307L63.7795 18L82.4998 25.7826Z" fill-rule="evenodd"
        stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
      <path
        d="M54.1958 21.9307V40.9481L54.2174 41.0146L73.4566 48.9228L82.6272 45.0147" stroke="#333333" stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M56.9998 41.7826L57.137 23.5173" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M60.0781 43.1951L59.9998 24.7826" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M63.0008 43.7826L63.0193 25.7644" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M65.9604 45.8892V26.8043" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M73.8037 48.8779V29.7939" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        clip-rule="evenodd"
        d="M82.6272 25.8662L63.7801 18L54.2174 21.9297L54.2291 21.9355L54.1958 21.9297V40.948L54.2174 41.0155L73.4566 48.9228L82.6272 45.0156V25.8662Z"
        fill-rule="evenodd"
        stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    </g>
    <g v-if="mountingMaterial === MountingMaterial.SNOW_FEET">
      <path
        d="M50.0001 47.4848V1.11133L10.7844 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        d="M50 47.4848V1.11133L89.2157 17.2712V63.7005" stroke="#CCCCCC" stroke-dasharray="3 3" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5" />
      <path
        clip-rule="evenodd" d="M49.8501 87.7128L0.980469 67.6262L49.8501 47.5415L98.7187 67.6262L49.8501 87.7128Z" fill-rule="evenodd"
        stroke="#CCCCCC"
        stroke-dasharray="3 3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
      <path
        class="brand-colored"
        d="M41.1155 54.3034L39.9725 57.0133L57.5 64.4999C59.7226 65.4374 59.1874 64.4035 59.503 63.6551C59.8187 62.9068 61.2226 62.9375 59 62L41.1155 54.3034Z" />
      <path
        class="brand-colored"
        d="M57.0001 62.5L58.5 65L67.5 61C69.7093 60.0315 68.9971 59.7438 68.671 59C68.3449 58.2562 70.0973 56.7466 67.8881 57.7152L57.0001 62.5Z" />
      <path
        class="brand-colored" clip-rule="evenodd"
        d="M39.887 54.721H42.8281V60.1666C42.8281 60.977 42.1697 61.634 41.3576 61.634C40.5454 61.634 39.887 60.977 39.887 60.1666V54.721ZM57.6517 61.6123H60.5928V68.0579C60.5928 68.8683 59.9344 69.5253 59.1223 69.5253C58.3101 69.5253 57.6517 68.8683 57.6517 68.0579V61.6123Z"
        fill-rule="evenodd" />
      <path
        class="brand-colored"
        d="M69.4706 58.587H66.5294V64.0326C66.5294 64.843 67.1878 65.5 68 65.5C68.8122 65.5 69.4706 64.843 69.4706 64.0326V58.587Z" />
      <path
        clip-rule="evenodd"
        d="M68.8098 39.0836L49.7804 31.2174L40.2176 35.1471L40.2294 35.1529L40.196 35.1471V54.1654L40.2176 54.2329L59.4568 62.1402L68.9647 58.2331L69.0206 58.1978V39.1129L68.8098 39.0836Z"
        fill="white"
        fill-rule="evenodd" />
      <path
        clip-rule="evenodd" d="M68.5 39L59.4572 43.0553L40.219 35.1481L49.7798 31.2174L68.5 39Z" fill-rule="evenodd" stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
      <path
        d="M40.196 35.1481V54.1655L40.2176 54.232L59.4568 62.1403L68.6274 58.2321" stroke="#333333" stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M43 55L43.1372 36.7347" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M46.0784 56.4125L46 38" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M49.001 57L49.0195 38.9818" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M51.9607 59.1066V40.0217" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        d="M59.804 62.0953V43.0114" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
      <path
        clip-rule="evenodd"
        d="M68.6274 39.0836L49.7804 31.2174L40.2176 35.1471L40.2294 35.1529L40.196 35.1471V54.1654L40.2176 54.2329L59.4568 62.1402L68.6274 58.2331V39.0836Z"
        fill-rule="evenodd"
        stroke="#333333"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.brand-va {
  .brand-colored {
    fill: #00917E;
  }
}

.brand-sd {
  .brand-colored {
    fill: #CC0033;
  }
}
</style>
